import { render } from "./UpdateAMI.vue?vue&type=template&id=56a1cd5a&scoped=true"
import script from "./UpdateAMI.vue?vue&type=script&lang=js"
export * from "./UpdateAMI.vue?vue&type=script&lang=js"

import "./UpdateAMI.vue?vue&type=style&index=0&id=56a1cd5a&scoped=true&lang=css"

import exportComponent from "/go/src/asuzs/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56a1cd5a"]])

export default __exports__